
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import DialogAlert from './DialogAlert';
import useAuth from '../hooks/useAuth';
import { getActions as authGetActions } from '../sagas/auth';

const classNames = mergeStyleSets({
    ResetPasswordForm: {
        backgroundColor: '#ffffff',
        width: '400px',
        padding: '16px'
    },
});


const ResetPasswordForm = ({rpc, onCancelClick}) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useAuth();

    const [username, setUsername] = useState('');
    const [passwordNew, setPasswordNew] = useState('');
    const [passwordNew2, setPasswordNew2] = useState('');

    const checkParams = () => {
        let errors = [];
        if (!username) {
            errors.push('Uživatelské jméno musí být zadané');
        }
        if (!(passwordNew && passwordNew2 && (passwordNew === passwordNew2))) {
            errors.push('Nové heslo a jeho potvrzení musí být zadané a musí se shodovat');
        }

        return errors;
    }

    const handleCancelClick = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    }

    const handleChangeClick = async (event) => {
        let errors = checkParams();
        if (errors.length === 0) {
            authActions.resetPassword(rpc, username, passwordNew);
        } else {
            await DialogAlert.show(errors.reduce(
                (previous, current) => {
                    return previous + `- ${current}<br/>`;
                }, 'Nejsou splněny následující podmínky a proto nelze ve změně hesla pokračovat:<br/></br/>'),
                {minWidth: 500});
        }
    }

    const handleChangeUsername = (event) => {
        setUsername(event.target.value);
    }

    const handleChangePasswordNew = (event) => {
        setPasswordNew(event.target.value);
    }

    const handleChangePasswordNew2 = (event) => {
        setPasswordNew2(event.target.value);
    }

    return (
        <Stack className={classNames.ResetPasswordForm} tokens={{childrenGap: 16}}>
            <Stack.Item>
                <TextField
                    label="Uživatelské jméno"
                    disabled={auth.operationLoading}
                    onChange={handleChangeUsername}
                />
                <TextField
                    label="Nové heslo"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.operationLoading}
                    onChange={handleChangePasswordNew}
                />
                <TextField
                    label="Potvrzení nového hesla"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.operationLoading}
                    onChange={handleChangePasswordNew2}
                />
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <PrimaryButton
                        text="Změnit heslo"
                        disabled={auth.operationLoading}
                        onClick={handleChangeClick}
                    />
                    <DefaultButton
                        text="Zpět"
                        onClick={handleCancelClick}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default ResetPasswordForm;
